<article class="activity-review">
  <app-vtmn-rating
    [emphasis]="true"
    [showValue]="true"
    [value]="review.rating?.code"
    [size]="ratingSizeEnum.SMALL"
  ></app-vtmn-rating>
  <header class="activity-review__inner">
    <h2 class="activity-review__username">
      {{ review.author?.username }}
      <time
        class="activity-review__time"
        [attr.datetime]="publisherDateFormatted(review.publisherDate)"
      >
        - {{ publisherDateFormatted(review.publisherDate) }}</time
      >
    </h2>
    <div class="activity-review__image-container" [ngStyle]="cssStyle"></div>
    <p *ngIf="activityName" class="activity-review__name">{{ activityName }}</p>
  </header>
  <div class="activity-review__details" [ngClass]="customDetailsBlockClass">
    <div class="activity-review__text" [innerText]="review.comment"></div>
    <ng-container *ngIf="reviewHasAnswers && isReviewsPage">
      <div
        *ngFor="let answer of review.answers"
        class="activity-review__answer"
      >
        <header class="activity-review__answer__header">
          <span [innerText]="'activity.reviews.answer' | translate"></span>
          <time
            class="activity-review__answer__header__date"
            [attr.datetime]="publisherDateFormatted(answer.createdAt)"
          >
            {{ publisherDateFormatted(answer.createdAt) }}
          </time>
        </header>
        <p
          class="activity-review__answer__text"
          [innerHtml]="answer.message | safeHtml"
        ></p>
      </div>
    </ng-container>

    <a
      *appIsEnabled="activityRatingTranslateToggle"
      href="#"
      class="activity-review__translate"
      [attr.ariaLabel]="'a11y.reviews.translate' | translate"
    >
      {{ 'reviews.translate' | translate }}
    </a>
  </div>
  <a
    *appIsEnabled="activityRatingReportToggle"
    href="#"
    class="activity-review__report"
    [attr.ariaLabel]="'a11y.reviews.report' | translate"
  >
    <vtmn-play-icon
      [name]="iconType?.WarningError"
      class="activity-review__icon"
    ></vtmn-play-icon>
    <span>{{ 'reviews.report' | translate }}</span>
  </a>
  <app-divider class="activity-review__divider" color="light-2"></app-divider>
</article>
